import type { MenuType } from './Menu'

export type LinkCompType = React.ComponentType<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }
>

export function hasItems(obj: MenuType) {
  return obj.items && Array.isArray(obj.items) && obj.items.length > 0
}

export function isExternal(url?: string) {
  return (url ?? '').startsWith('https')
}

const cdnUrl =
  'https://marketing-cdn.3plearning.com/uploads/assets/readingeggs-pflw/'

export function getCdnUrl(path: string) {
  return `${cdnUrl}${path}`
}
